import { Injectable } from '@angular/core';

import { SettingsResponse } from '@reach/interfaces/settings/settings.interface';
import { DeepPartial } from '@reach/interfaces/typescript/deep-partial';
import { UserPreferences } from '@reach/interfaces/user/preferences.interface';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class SettingsApiService extends BaseApiService {
	protected commonPath = ['settings'];

	public async get(): Promise<SettingsResponse> {
		const params = { t: this.paramTime };
		return await this.http.get<SettingsResponse>(this.url(), params);
	}

	public async update(settings: DeepPartial<UserPreferences>): Promise<SettingsResponse> {
		return await this.http.patch<SettingsResponse>(this.url(), settings);
	}
}
